import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import "./GroupsDialog.css";
import PromptModal from "./PromptModal";
import AlertModal from "./AlertModal";
import MultiSelectModal from "./MultiSelectModal";
import IconsDialog from "./IconsDialog";
import Place from "../../Models/Place";

function resolveImgUrl(url) {
  if (!url) return "";
  if (url.startsWith("gdrive:")) return `https://lh3.googleusercontent.com/d/${url.slice(7)}`;
  return url;
}

class GroupsDialog extends Component {
  constructor(props) {
    super(props);
    let list_to_display = [];
    if (window.guide_obj !== null && typeof window.guide_obj !== "undefined")
      list_to_display = window.guide_obj.getGroupsToDisplay();
    this.state = {
      list_to_display,
      searchText: "",

      PromptModalShow: false,
      PromptModalTitle: "Enter Value",
      PromptModalMessage: "",
      PromptModalButtons: [],
      PromptModalInputs: [],

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],

      IconsDialogShow: false,

      // Schedule picker
      SchedulePickerShow: false,
      SchedulePickerItems: [],
      SchedulePickerSelected: [],

      // Image picker
      ImagePickerShow: false,
      ImagePickerItems: [],
      ImagePickerSelected: [],

      currentGroup: null,
    };
  }

  componentDidMount() {
    this.getList();
  }

  getList = () => {
    let list_to_display = [];
    if (window.guide_obj !== null && typeof window.guide_obj !== "undefined")
      list_to_display = window.guide_obj.getGroupsToDisplay();
    this.setState({ list_to_display });
  };

  MyAlert = (title, message, buttons) => {
    this.setState({ AlertModalTitle: title, AlertModalMessage: message, AlertModalButtons: buttons, AlertModalShow: true });
  };

  _group_obj = null;

  addModifyGroup = (add, group) => {
    this._group_obj = group;
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Group",
      PromptModalMessage: add ? "Enter Group Name" : "Edit Group Name",
      PromptModalButtons: [
        { Title: "OK", Method: add ? this.AddGroupCallback : this.ModifyGroupNameCallback },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Group Name", value: add ? "" : group.name }],
    });
  };

  ModifyGroupNameCallback = (inputs) => {
    if (inputs === null) return;
    const newGroupName = inputs[0].value;
    const grpVal = this._group_obj.value;
    const updated = { ...grpVal, name: newGroupName };
    window.guide_obj.modifyGroup(updated, updated);
    this.getList();
    if (this.props.update_display !== null) this.props.update_display();
  };

  AddGroupCallback = (inputs) => {
    if (inputs === null) return;
    window.guide_obj.addGroup(inputs[0].value);
    this.getList();
    if (this.props.update_display !== null) this.props.update_display();
  };

  deleteGroup = (group) => {
    this.MyAlert("Confirmation", "Confirm Delete Group?", [
      { Title: "OK", Method: () => this._deleteGroup(group) },
      { Title: "CANCEL", Method: null },
    ]);
  };

  _deleteGroup = (group) => {
    window.guide_obj.deleteGroup(group);
    this.getList();
  };

  UpdateIcon = (icon) => {
    this._group_obj.value.poi_img = icon.id;
    this._group_obj.value.url = icon.value;
    window.guide_obj.modifyGroup(this._group_obj.value, this._group_obj.value);
    if (this.props.update_display) this.props.update_display();
  };

  ChangeIcon = (group) => {
    this._group_obj = group;
    this.setState({ IconsDialogShow: true });
  };

  // ── Mosaic toggle ──────────────────────────────────────────
  toggleMosaic = (item) => {
    const updated = { ...item.value, mosaic: !item.value.mosaic };
    window.guide_obj.modifyGroup(updated, updated);
    this.getList();
    if (this.props.update_display) this.props.update_display();
  };

  // ── Schedule picker ────────────────────────────────────────
  openSchedulePicker = (item) => {
    const schedNames = window.guide_obj.schedule.geScheduleNames().filter(s => s.label !== "Main");
    const items = [
      { id: "", label: "(none)", value: "", name: "" },
      ...schedNames.map(s => ({ id: s.label, label: s.label, value: s.label, name: s.label })),
    ];
    const current = item.value.schedule || "";
    const selected = items.filter(i => i.value === current);
    this.setState({ SchedulePickerShow: true, SchedulePickerItems: items, SchedulePickerSelected: selected, currentGroup: item });
  };

  schedulePickerCallback = (selected) => {
    const { currentGroup } = this.state;
    if (!currentGroup) return;
    const schedName = selected.length > 0 ? selected[0].value : "";
    const updated = { ...currentGroup.value, schedule: schedName };
    window.guide_obj.modifyGroup(updated, updated);
    this.getList();
    if (this.props.update_display) this.props.update_display();
  };

  // ── Image picker ───────────────────────────────────────────
  openImagePicker = (item) => {
    const groupId = item.value.id;
    const places = window.guide_obj.places.placesList.filter(p =>
      p.getGroups().includes(groupId) && (p.Photo_m || p.Photo)
    );
    const items = places.map(p => {
      const raw = p.Photo_m || p.Photo || "";
      const fallback = p.Photo || "";
      return {
        id: p.ID,
        label: p.Name,
        value: raw,
        thumb: resolveImgUrl(raw),
        thumbFallback: resolveImgUrl(fallback),
        name: p.Name,
      };
    });
    const currentImg = item.value.image || "";
    const selected = items.filter(i => i.value === currentImg);
    this.setState({ ImagePickerShow: true, ImagePickerItems: items, ImagePickerSelected: selected, currentGroup: item });
  };

  imagePickerCallback = (selected) => {
    const { currentGroup } = this.state;
    if (!currentGroup) return;
    const imageUrl = selected.length > 0 ? selected[0].value : "";
    const updated = { ...currentGroup.value, image: imageUrl };
    window.guide_obj.modifyGroup(updated, updated);
    this.getList();
    if (this.props.update_display) this.props.update_display();
  };

  handleSearchChanged = (event) => {
    this.setState({ searchText: event.target.value });
    let list_to_display = window.guide_obj.getGroupsToDisplay();
    const _searchText = event.target.value.toUpperCase();
    this.setState({ list_to_display: list_to_display.filter(i => i.label.toUpperCase().includes(_searchText)) });
  };

  render() {
    let list_to_display = this.state.list_to_display || [];

    return (
      <div className="modal">
        <Modal
          {...this.props}
          dialogClassName="grpdlg-dialog"
          aria-labelledby="contained-modal-title-vcenter"
          centered={false}
          scrollable={false}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="grpdlg-shell">

              {/* ── Header ── */}
              <div className="grpdlg-header">
                <div className="grpdlg-header-icon">
                  <FontAwesomeIcon icon={solid("object-group")} />
                </div>
                <h2 className="grpdlg-title">Groups</h2>
                <button className="grpdlg-close" onClick={this.props.onHide}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              {/* ── Search row ── */}
              <div className="grpdlg-search-row">
                <div className="grpdlg-search">
                  <FontAwesomeIcon icon={solid("magnifying-glass")} className="grpdlg-search-icon" />
                  <input
                    type="text"
                    placeholder="Search"
                    value={this.state.searchText}
                    onChange={this.handleSearchChanged}
                  />
                </div>
                <button className="grpdlg-add-btn" title="Add group" onClick={() => this.addModifyGroup(true, null)}>
                  <FontAwesomeIcon icon={solid("plus")} />
                </button>
              </div>

              {/* ── List ── */}
              <div className="grpdlg-list">
                {list_to_display.map((item, index) => {
                  const iconSrc = Place.getItemPOIImage(item.value);
                  const grp = item.value;
                  return (
                    <div className="grpdlg-item" key={index}>
                      <div className="grpdlg-item-thumb" title="Change Icon" onClick={() => this.ChangeIcon(item)}>
                        {iconSrc != null ? (
                          <img alt="" src={iconSrc} />
                        ) : (
                          <span className="grpdlg-item-thumb-placeholder">
                            <FontAwesomeIcon icon={solid("object-group")} />
                          </span>
                        )}
                      </div>
                      <div className="grpdlg-item-info">
                        <span className="grpdlg-item-label">{item.label}</span>
                        {grp.schedule ? <span className="grpdlg-item-schedule">{grp.schedule}</span> : null}
                      </div>
                      <div className="grpdlg-item-actions">
                        <button
                          className={`grpdlg-icon-btn${grp.mosaic ? " active" : ""}`}
                          title={grp.mosaic ? "In Mosaic (click to remove)" : "Not in Mosaic (click to add)"}
                          onClick={() => this.toggleMosaic(item)}
                        >
                          <FontAwesomeIcon icon={solid("images")} />
                        </button>
                        <button
                          className={`grpdlg-icon-btn${grp.image ? " active" : ""}`}
                          title="Set mosaic cover image"
                          onClick={() => this.openImagePicker(item)}
                        >
                          <FontAwesomeIcon icon={solid("image")} />
                        </button>
                        <button
                          className={`grpdlg-icon-btn${grp.schedule ? " active" : ""}`}
                          title="Link to schedule"
                          onClick={() => this.openSchedulePicker(item)}
                        >
                          <FontAwesomeIcon icon={solid("calendar-days")} />
                        </button>
                        <button className="grpdlg-icon-btn" title="Rename" onClick={() => this.addModifyGroup(false, item)}>
                          <FontAwesomeIcon icon={solid("pen")} />
                        </button>
                        <button className="grpdlg-icon-btn danger" title="Delete" onClick={() => this.deleteGroup(item)}>
                          <FontAwesomeIcon icon={solid("trash")} />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>

            </div>
          </Modal.Body>
        </Modal>

        <PromptModal
          show={this.state.PromptModalShow}
          onHide={() => this.setState({ PromptModalShow: false })}
          PromptModalTitle={this.state.PromptModalTitle}
          PromptModalMessage={this.state.PromptModalMessage}
          PromptModalButtons={this.state.PromptModalButtons}
          PromptModalInputs={this.state.PromptModalInputs}
        />
        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
        <IconsDialog
          show={this.state.IconsDialogShow}
          onHide={() => this.setState({ IconsDialogShow: false })}
          update_icon={this.UpdateIcon}
        />
        <MultiSelectModal
          show={this.state.SchedulePickerShow}
          onHide={() => this.setState({ SchedulePickerShow: false })}
          MultiselectItems={this.state.SchedulePickerItems}
          MultiselectSelectedItems={this.state.SchedulePickerSelected}
          MultiselectMode="uni"
          MultiselectCallback={this.schedulePickerCallback}
          MultiselectTitle="Link to Schedule"
          MultiselectSearchText=""
        />
        <MultiSelectModal
          show={this.state.ImagePickerShow}
          onHide={() => this.setState({ ImagePickerShow: false })}
          MultiselectItems={this.state.ImagePickerItems}
          MultiselectSelectedItems={this.state.ImagePickerSelected}
          MultiselectMode="uni"
          MultiselectDisplayMode="photo-grid"
          MultiselectCallback={this.imagePickerCallback}
          MultiselectTitle="Select Cover Image"
          MultiselectSearchText=""
        />
      </div>
    );
  }
}

export default GroupsDialog;
